import { Text } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { getFormattedCurrency } from '../../../utils/business/prices';
import InputCheckbox from '../../generic/form/InputCheckbox';

const textProps = {
  as: 'span',
  fontSize: 'xs',
};

export const DEPOSIT_FIELDNAME = 'deposit';

const CheckoutDeposit = ({ deposit, checkoutData, canPayOnSite = true, ...dataProps }) => {
  if (checkoutData.payment_amount == null) return <></>;

  let paymentAmount = parseFloat(checkoutData.payment_amount);
  if (!checkoutData.vakario_fee_included && checkoutData.vakario_fee != null) paymentAmount += parseFloat(checkoutData.vakario_fee);

  // Without a working payment setup, paying nothing now would let the booking through unpaid
  if (paymentAmount == 0 && !canPayOnSite) return <></>;

  return (
    <InputCheckbox fieldName={DEPOSIT_FIELDNAME} {...dataProps} fieldValue={deposit} isRequired={false}>
      {paymentAmount > 0 && (
        <>
          <Text {...textProps}>
            <Trans>Pay only the deposit</Trans>{' '}
          </Text>
          <Text {...textProps}> {getFormattedCurrency(paymentAmount)}</Text>
        </>
      )}
      {paymentAmount == 0 && (
        <Text {...textProps}>
          <Trans>Pay on site</Trans>
        </Text>
      )}
    </InputCheckbox>
  );
};

export default CheckoutDeposit;
